
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { AnalysisView } from "./components/AnalysisView.tsx";
import "./index.css";

if (window.location.pathname === '/analysis') {
  createRoot(document.getElementById("root")!).render(<AnalysisView />);
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
